import { useRef, useState } from "react";
import { Form } from "./Form";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { IPoIncDistribution, Table } from "./Table";
import { EmptyIncDist } from "./EmptyIncDist";

export interface IModal{
    singleData: IPoIncDistribution,
    open: boolean  
}

export const PO_Incentive_Distribution = (permissions: IPermissionProps) => {
    const [modal,setModal] = useState({singleData: {}, open: false} as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyIncDist, open: false});
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}